import { ThemeUICSSObject } from '@apia/theme';
import { chat } from './chat';
/* IMPORT HERE */

export const gpt: ThemeUICSSObject = {
  chat,
  /* PREPEND HERE */
};
